// extracted by mini-css-extract-plugin
module.exports = {"LinkWrapper":"ElementLink_LinkWrapper__1v0Or"};